import BaseService from "../BaseService";

export default class WeitergabeService extends BaseService {

  constructor() {
    super('weitergabe')
  }
}
